import { render, staticRenderFns } from "./backIcon.vue?vue&type=template&id=5a730216&"
import script from "./backIcon.vue?vue&type=script&lang=js&"
export * from "./backIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports